var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVdNightclubBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_203)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#CD2226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.075 10.8504C14.8956 10.8504 14.75 10.996 14.75 11.1754V12.8004C14.75 12.92 14.6529 13.0171 14.5333 13.0171C14.4137 13.0171 14.3166 12.92 14.3166 12.8004V10.0921C14.3166 9.91266 14.171 9.76706 13.9916 9.76706C13.8122 9.76706 13.6666 9.91266 13.6666 10.0921V12.8004C13.6666 12.92 13.5696 13.0171 13.45 13.0171C13.3304 13.0171 13.2333 12.92 13.2333 12.8004V9.22539C13.2333 9.04599 13.0877 8.90039 12.9083 8.90039C12.7289 8.90039 12.5833 9.04599 12.5833 9.22539V12.8004C12.5833 12.92 12.4862 13.0171 12.3666 13.0171C12.247 13.0171 12.15 12.92 12.15 12.8004V9.87539C12.15 9.69599 12.0044 9.55039 11.825 9.55039C11.6456 9.55039 11.5 9.69599 11.5 9.87539V12.8004C11.5 12.92 11.4029 13.0171 11.2833 13.0171C11.1637 13.0171 11.0666 12.92 11.0666 12.8004V11.8254C11.0666 11.646 10.921 11.5004 10.7416 11.5004C10.5622 11.5004 10.4166 11.646 10.4166 11.8254V13.0171V14.1004V14.3171C10.4166 14.9153 10.9017 15.4004 11.5 15.4004H14.3166C14.9148 15.4004 15.4 14.9153 15.4 14.3171V13.2454V13.0171V11.1754C15.4 10.996 15.2544 10.8504 15.075 10.8504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11664 10.6329C9.95427 10.6329 10.6333 9.95391 10.6333 9.11628C10.6333 8.27864 9.95427 7.59961 9.11664 7.59961C8.27901 7.59961 7.59998 8.27864 7.59998 9.11628C7.59998 9.95391 8.27901 10.6329 9.11664 10.6329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98333 11.825C9.98333 11.4068 10.3235 11.0667 10.7417 11.0667C10.858 11.0667 10.9681 11.0931 11.0667 11.1399V9.875C11.0667 9.45683 11.4068 9.11667 11.825 9.11667C11.9416 9.11667 12.0521 9.1431 12.1506 9.19033C12.1691 8.7882 12.5019 8.46667 12.9083 8.46667C13.0063 8.46667 13.0992 8.48682 13.1852 8.52083C12.8949 6.53292 11.1837 5 9.11667 5C6.84665 5 5 6.84665 5 9.11667C5 11.3867 6.84665 13.2333 9.11667 13.2333C9.41155 13.2333 9.7008 13.2013 9.98333 13.1404V11.825ZM7.16667 9.11667C7.16667 8.04157 8.04157 7.16667 9.11667 7.16667C10.1918 7.16667 11.0667 8.04157 11.0667 9.11667C11.0667 10.1918 10.1918 11.0667 9.11667 11.0667C8.04157 11.0667 7.16667 10.1918 7.16667 9.11667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdNightclubBar);
export default __webpack_public_path__ + "static/media/VDNightclubBar.819555c5b959db4b71f579dbbb03230d.svg";
export { ForwardRef as ReactComponent };